import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';

const PreStyled = styled(Box)`
    white-space: pre-wrap;
    word-break: normal;
    word-wrap: break-word;
`;

export default PreStyled;
